import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { MoreVertical, Calendar, User as UserIcon, Users2, History, LogOut } from "lucide-react";
import { useAuth } from "@/lib/auth";

/**
 * 3-dot (kebab) menu for the logged-in end-client.
 * Shown in the public Landing header when `user.role === "client"`,
 * replacing the anonymous "Entrar" button.
 */
export default function ClientKebabMenu({ userName }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const { logout } = useAuth();

  useEffect(() => {
    const onDocClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);

  const items = [
    { to: "/client-portal", icon: Calendar, label: "Painel" },
    { to: "/client-portal/bookings", icon: Calendar, label: "Reservas" },
    { to: "/client-portal/profile", icon: UserIcon, label: "Perfil" },
    { to: "/client-portal/referrals", icon: Users2, label: "Convidados" },
    { to: "/client-portal/bookings?filter=past", icon: History, label: "Histórico" },
  ];

  return (
    <div className="dt-kebab" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        data-testid="client-kebab-btn"
        aria-label="Menu do cliente"
        className="dt-kebab__trigger"
      >
        <MoreVertical size={16} />
      </button>
      {open && (
        <div className="dt-kebab__panel" data-testid="client-kebab-menu">
          {userName && (
            <div className="dt-kebab__user">{userName}</div>
          )}
          {items.map((it) => (
            <Link
              key={it.to}
              to={it.to}
              onClick={() => setOpen(false)}
              data-testid={`kebab-${it.label.toLowerCase()}`}
              className="dt-kebab__item"
            >
              <it.icon size={14} /> {it.label}
            </Link>
          ))}
          <button
            type="button"
            onClick={() => { setOpen(false); logout?.(); }}
            data-testid="kebab-logout"
            className="dt-kebab__item dt-kebab__item--danger"
          >
            <LogOut size={14} /> Sair
          </button>
        </div>
      )}
    </div>
  );
}
